export default "__VITE_ASSET__a6231608__"